export default __webpack_public_path__ + "static/media/construction.fc5a3c38.png";